// extracted by mini-css-extract-plugin
export default {"myAccountLayout":"MyAccountLayout_myAccountLayout__x+xbB","tabs":"MyAccountLayout_tabs__6DHwj","tabList":"MyAccountLayout_tabList__ipoEb"};